<template>

    <div>
        <b-row v-if="!isAdmin" align-h="center" class="ml-n5 mt-5">
            <b-col class="report-list mr-5" lg="3">
                <p @click="goRouter('Reporte-Simulacro')">Reporte del simulacro</p>
              
            </b-col>
               <b-col class="report-list ml-5"  lg="3">
            <p @click="goRouter('Reporte-Consulta')">Reporte de la encuesta</p>  
            </b-col>
        </b-row>
           <b-row v-if="isAdmin" align-h="center" class="ml-n5 mt-5">
            <b-col class="report-list mr-5" lg="3">
                <p @click="goRouter('Reporte-Simulacro-Admin')">Reporte del simulacro</p>
              
            </b-col>
               <b-col class="report-list ml-5"  lg="3">
            <p @click="goRouter('Reporte-Consulta-Admin')">Reporte de la encuesta</p>  
            </b-col>
        </b-row>
        
    </div>
</template>
<script>
    export default {
        name: 'select-report',
        props: {
            url: String,
        },
        data: () => ({
            simulacros: ''
        }),
        created() {
                        this.$store.dispatch('setNav', 'active')

            this.$store.dispatch('getSimulacros')
                .then((response) => {
                    this.simulacros = response.data.simulacro
                })

        },
    methods: {
      goRouter(link) {
            //this.$store.dispatch('setSimulacros', id)
            this.$router.push({ name: link})
      }
    },
      computed: {
    isAdmin() {
      return this.$store.getters["isAdmin"];
    },
    }
}
</script>
<style scoped>
</style>